// extracted by mini-css-extract-plugin
module.exports = {"alignmentControls":"textAlignment_alignmentControls__G2W6y"};